import { Message } from '../../../type';
import { useIntl } from 'react-intl';
import { Typography } from '@mui/material';

export const DeletedMessage = (props: { message: Message }) => {
  const { deletedBy } = props.message;
  const intl = useIntl();
  const text = deletedBy
    ? 'messages.deleted.by-user'
    : 'messages.deleted.by-policy';
  return (
    <Typography sx={{ fontStyle: 'italic', fontSize: 16 }}>
      {intl.formatMessage({ id: text })}
    </Typography>
  );
};
